<main>
  <router-outlet></router-outlet>
</main>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p style="color: white">Carregando...</p>
</ngx-spinner>